var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeletei = function SvgDeletei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Trigger Area"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M7.221 21a1.75 1.75 0 0 1-1.7-1.791V6.968A.75.75 0 0 1 6.25 6.2a.75.75 0 0 1 .727.768v12.241a.25.25 0 0 0 .242.256h9.558a.25.25 0 0 0 .242-.256V6.968a.75.75 0 0 1 .727-.768.75.75 0 0 1 .727.768v12.241a1.747 1.747 0 0 1-1.7 1.791zm5.989-4.353V8.452a.747.747 0 0 1 .728-.768.747.747 0 0 1 .729.768v8.195a.75.75 0 0 1-.729.768.75.75 0 0 1-.728-.768m-3.877 0V8.452a.746.746 0 0 1 .726-.768.745.745 0 0 1 .727.768v8.195a.747.747 0 0 1-.727.768.75.75 0 0 1-.726-.768m4.742-11.013H4.727a.75.75 0 0 1-.729-.768.747.747 0 0 1 .729-.768h4.466v-.331a.75.75 0 0 1 .728-.768h4.154a.747.747 0 0 1 .728.768v.331h4.468a.75.75 0 0 1 .728.768.75.75 0 0 1-.728.768z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeletei);
export default ForwardRef;